import React from 'react';
import {
  Line,
  LineChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { ChartCard } from '../components/ChartCard';
import { DepartmentCockpit } from '../components/DepartmentCockpit';
import { operationalMetrics } from '../lib/mock-data';

export function OperationsPage() {
  return (
    <div className="pb-12">
      <DepartmentCockpit
        section="operations"
        pageTitle="Reliability & Throughput"
        pageEyebrow="Operations Dashboard"
        pageDescription="Real-time operational health surfaced from monitoring APIs and ITSM."
      >
        {() => <OperationsCharts />}
      </DepartmentCockpit>
    </div>
  );
}

function OperationsCharts() {
  const data = operationalMetrics;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-2">
      <ChartCard
        title="Uptime - last 6 weeks"
        subtitle="% availability"
        className="h-[300px]"
      >
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
          >
            <CartesianGrid
              stroke="var(--color-border)"
              vertical={false}
            />

            <XAxis
              dataKey="week"
              stroke="var(--color-muted-foreground)"
              fontSize={11}
              tickLine={false}
              axisLine={false}
            />

            <YAxis
              stroke="var(--color-muted-foreground)"
              fontSize={11}
              tickLine={false}
              axisLine={false}
              domain={[99.8, 100]}
            />

            <Tooltip
              contentStyle={{
                background: 'var(--color-popover)',
                border: '1px solid var(--color-border)',
                borderRadius: 8,
                fontSize: 12,
              }}
            />

            <Line
              type="monotone"
              dataKey="uptime"
              stroke="oklch(0.74 0.18 155)"
              strokeWidth={2.5}
              dot={{
                fill: 'oklch(0.74 0.18 155)',
                r: 3,
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </ChartCard>
    </div>
  );
}
